import { WorkRecord } from './work-record';
import { DragAndDropItem } from 'app/shared/drag-and-drop/drag-and-drop-item.interface';
import { ROLE } from './roles.const';

export class User implements DragAndDropItem {

  constructor(
    private id: UserId,
    private roles: string[],
    public name: string,
    public surname: string,
    public phone: string,
    public email: string,
    public language: string,
    public workRecord: WorkRecord
  ) { }

  public getId(): string {
    return this.id;
  }

  public getRoles(): string[] {
    return this.roles;
  }

  public hasRole(role: string): boolean {
    return -1 !== this.roles.indexOf(role);
  }

  public get fullName(): string {
    return this.name + ' ' + this.surname;
  }

  public getLabel(): string {
    return this.fullName + ' ' + this.email
  }

  public getDragAndDropElements(): User[] {
    return [this];
  }

  public hasParticipantRole(): boolean {
    return this.hasRole(ROLE.PARTICIPANT);
  }

  public hasAdminRole(): boolean {
    return this.hasRole(ROLE.ADMIN) || this.hasRole(ROLE.SUPER_ADMIN);
  }
}

export type UserId = string;



// WEBPACK FOOTER //
// /dist/src/app/user/user.model.ts